import { defineMessages } from 'react-intl';

export const filterCompositionMenuGroupMessages = defineMessages({
  groupLabel: {
    defaultMessage: 'Filter',
    id: '5TvbdN1qCaWnlbUM',
    description:
      'Label of the menu group holding the filter items rendered by FilterCompositionMenuGroup.',
  },
  filterByStatement: {
    defaultMessage: 'Filter by {statement}',
    id: '/zJ82FZ2E8C23Qci',
    description:
      'Label of a menu item that adds a filter statement, e.g. "Filter by status = INFO".',
  },
  removeFiltersForKey: {
    defaultMessage: 'Remove filters for {key}',
    id: 'k1Ux+CdMPZAz2/QP',
    description:
      'Label of the menu item that removes every filter statement for a key.',
  },
  exists: {
    defaultMessage: 'Exists',
    id: 'BEVBtJceKjGzK+w4',
    description:
      'Operator name suffix for the "exists" filter item, shown after the statement label.',
  },
  notExists: {
    defaultMessage: "Doesn't exist",
    id: 'RuEjUW6uMDS+tSIZ',
    description:
      'Operator name suffix for the "not exists" filter item, shown after the statement label.',
  },
  alreadySelected: {
    defaultMessage: 'Filter is already selected',
    id: 'cilisOHA0Q0L+ZDh',
    description:
      'Tooltip on a disabled filter item whose exact statement is already applied.',
  },
  conflictsWithSelection: {
    defaultMessage: 'Filter conflicts with current selection',
    id: 'goXPTTmE++ZY6g8I',
    description:
      'Tooltip on a disabled filter item that contradicts a statement already applied.',
  },
});
